import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { JsonLd } from "../Seo";

export const FAQ_ITEMS = [
  {
    q: "What is private credit?",
    a: "Private credit is lending that happens outside the banking system. Specialist fund managers raise capital from investors and lend it directly to businesses, property developers and other borrowers — setting their own terms, pricing and structures rather than following bank credit policy.",
  },
  {
    q: "How big is Australia's private credit market?",
    a: "Australian private credit reached A$234.5b in 2025, compounding at roughly 21% a year since 2015 — against about 5.5% annual growth in bank lending over the same period — and is forecast to approach A$300b by 2029 (EY-Parthenon).",
  },
  {
    q: "What is ASIC Report 814?",
    a: "REP 814 is ASIC's September 2025 review of the private credit sector. It examined how funds handle fees, conflicts of interest and asset valuations, and set expectations for independent valuations, transparent fee treatment and honest marketing labels. Our explainers break down what it means for investors and borrowers.",
  },
  {
    q: "Who can invest in private credit funds?",
    a: "Most Australian private credit funds are open to wholesale investors under the Corporations Act — generally people meeting certain wealth or income thresholds. This site provides factual, general information only and does not recommend any fund; obtain independent professional advice before investing.",
  },
  {
    q: "I'm a borrower. How do I apply for funding?",
    a: "Use the borrower enquiry form on this page — tell us the entity, the loan amount and the facility type you need. Enquiries are routed to Grow Capital, who will respond to discuss your requirements.",
  },
  {
    q: "Is anything on this site financial advice?",
    a: "No. Everything here is factual and general in nature, prepared without considering any person's objectives, financial situation or needs. The directory lists public facts only — no ratings, no rankings, no endorsements. See the general advice warning in the footer.",
  },
].map(({ q, a }) => ({ q, a }));

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ_ITEMS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="terminal-faq" className="py-20 border-b border-line max-w-6xl mx-auto px-6" data-testid="faq-section">
      <JsonLd data={faqSchema} />
      <div className="mb-10">
        <span className="text-xs font-mono text-cy uppercase tracking-widest">[05] REFERENCE DESK</span>
        <h2 className="font-display text-4xl text-white uppercase mt-2">Frequently Asked Questions</h2>
      </div>

      <div className="divide-y divide-line border border-line rounded-xl overflow-hidden bg-surface">
        {FAQ_ITEMS.map((f, i) => (
          <div key={f.q}>
            <button
              type="button"
              onClick={() => setOpen(open === i ? -1 : i)}
              data-testid={`faq-question-${i}`}
              aria-expanded={open === i}
              className="w-full flex items-center justify-between gap-4 p-5 text-left hover:bg-navy-alt transition-colors"
            >
              <span className="font-body font-semibold text-white text-sm md:text-base">{f.q}</span>
              <ChevronDown
                className={`w-4 h-4 text-cy shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`}
              />
            </button>
            {open === i && (
              <div className="px-5 pb-5 text-sm text-mut font-body leading-relaxed" data-testid={`faq-answer-${i}`}>
                {f.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};
